////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const salesControl = {
	[ActionsTypes.GET_SALES_Control]: (state) =>
		update(state, {
			salesControl: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.GET_SALES_CONTROL_SUCCESS]: (state, payload) => {
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}
		return update(state, {
			salesControl: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: payload.data.headerContent.contentPagined.content,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: payload.data.headerParam.filters,
				},
			},
		})
	},
	[ActionsTypes.GET_SALES_CONTROL_FAILURE]: (state, payload) =>
		update(state, {
			salesControl: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.RESET_SALES_CODE_ITEMS]: (state, _payload) => {
		return update(state, {
			salesControl: {
				items: {
					$set: [],
				},
				header: {
					$set: {},
				},
			},
		})
	},
}

export default salesControl
